
import React, { useEffect } from "react";
import { StrategyWithDetails, StrategyProvider, StrategyPerformance, Account } from "@/types/strategy-types";
import DashboardHeader from "./components/DashboardHeader";
import StatCardsGrid from "./components/StatCardsGrid";
import AccountSummaryCard from "./components/AccountSummaryCard";
import ReferralStatsCard from "./components/ReferralStatsCard";

interface AdminDashboardProps {
  users?: any[];
  strategies?: StrategyWithDetails[];
  providers?: StrategyProvider[];
  accountPerformances?: StrategyPerformance[];
  accounts?: Account[];
  leadAccounts?: any[];
  stripeSubscriptions?: {
    monthly: number;
    yearly: number;
    total: number;
    activeCanceled: number;
    subscriptions: any[];
  };
}

const AdminDashboard: React.FC<AdminDashboardProps> = ({
  users,
  strategies,
  providers,
  accounts,
  leadAccounts,
  stripeSubscriptions
}) => {
  console.log("AdminDashboard rendering with users:", users?.length);
  
  // Debug referral data that we now get directly from the database
  React.useEffect(() => {
    if (users?.length) {
      const usersWithReferrals = users.filter(user => 
        user.referral_relationships && user.referral_relationships.length > 0
      );
      
      console.log(`Found ${usersWithReferrals.length} users who have referred others`);
      
      let totalReferrals = 0;
      let paidReferrals = 0;
      
      users.forEach(user => {
        const relationships = user.referral_relationships || [];
        totalReferrals += relationships.length;
        
        const paid = relationships.filter(rel => rel.paid_status).length;
        paidReferrals += paid;
        
        if (relationships.length > 0) {
          console.log(`User ${user.id} has ${relationships.length} referrals, ${paid} paid`);
        }
      });
      
      console.log(`Total referrals: ${totalReferrals}, Paid: ${paidReferrals}, Free: ${totalReferrals - paidReferrals}`);
    }
  }, [users]);
  
  return (
    <div className="space-y-6 pb-16">
      <DashboardHeader />
      
      <StatCardsGrid 
        users={users}
        strategies={strategies}
        providers={providers}
        stripeSubscriptions={stripeSubscriptions}
      />
      
      <ReferralStatsCard users={users} />
      
      <div className="grid gap-4 md:grid-cols-1">
        <AccountSummaryCard 
          accounts={accounts}
          leadAccounts={leadAccounts}
        />
      </div>
    </div>
  );
};

export default AdminDashboard;
